import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentPositionsDataFacade } from '@core/tellent-positions-logic';
import { PositionDetailsDialogData, TellentPosition } from '@core/tellent-positions-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  EmptyStateComponent,
  IconButtonComponent,
  IconComponent,
  TabComponent,
  TabsComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-position-details-dialog',
  templateUrl: './position-details-dialog.component.html',
  styleUrls: ['./position-details-dialog.component.less'],
  imports: [
    DialogBodyComponent,
    IconComponent,
    TranslatePipe,
    TabsComponent,
    TabComponent,
    EmptyStateComponent,
    ButtonComponent,
    IconButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionDetailsDialogComponent implements DialogComponentI<
  PositionDetailsDialogData,
  any
> {
  private readonly positionsDataFacade = inject(TellentPositionsDataFacade);

  public positionData: Signal<TellentPosition | null>;

  public setDialogData(data: PositionDetailsDialogData): void {
    this.positionsDataFacade.fetchOne(data.positionGuid);
    this.positionData = this.positionsDataFacade.getPositionById(data.positionGuid);
  }
}
